"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/ui/components");
var _validators = require("vuelidate/lib/validators");
var _utils = require("@/utils");
var _constants = require("@/config/constants");
var _vuex = require("vuex");
var _moment = _interopRequireDefault(require("moment"));
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var validCPF = function validCPF(value) {
  return (0, _utils.validateCPF)(value);
};
var validDate = function validDate(value) {
  return (0, _utils.validateDateGeneral)(value);
};
var _default2 = exports.default = {
  name: 'ModalTeamForm',
  components: {
    AppSelect: _components.AppSelect,
    AppInput: _components.AppInput
  },
  data: function data() {
    return {
      error: false,
      emailError: false,
      phoneError: false,
      errortemporaryExpirationDate: false,
      errorPassword: false,
      imageBase64: '',
      imageUrl: '',
      showPassword: true,
      userExist: false,
      userExistData: {},
      userData: {
        file: null,
        cpf: '',
        firstName: '',
        lastName: '',
        role: null,
        temporary: false,
        temporaryExpirationDate: null,
        scholarship: null,
        email: '',
        phone: '',
        date: '',
        password: null,
        passwordConfirm: null,
        birthdate: '',
        manager: null
      },
      errors: [],
      quantitys: null,
      roles: _constants.ROLES_USERS_FUNCTIONS,
      schoolings: _constants.SCHOOLINGS,
      listTemporay: [{
        description: 'Sim',
        value: true
      }, {
        description: 'Não',
        value: false
      }]
    };
  },
  props: {
    userEdit: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    getUsers: {
      type: Function,
      default: function _default() {}
    }
  },
  validations: function validations() {
    if (this.userData.role === 'Operator') {
      return {
        userData: {
          cpf: {
            required: _validators.required,
            min: (0, _validators.minLength)(10),
            validCPF: validCPF
          },
          firstName: {
            required: _validators.required,
            min: (0, _validators.minLength)(2)
          },
          lastName: {
            required: _validators.required,
            min: (0, _validators.minLength)(1)
          },
          role: {
            required: _validators.required,
            min: (0, _validators.minLength)(2)
          },
          temporary: {
            required: _validators.required
          },
          temporaryExpirationDate: {
            max: (0, _validators.maxLength)(10)
          },
          scholarship: {
            required: _validators.required
          },
          password: {
            min: (0, _validators.minLength)(6)
          },
          passwordConfirm: {
            sameAsPassword: (0, _validators.sameAs)('password')
          },
          email: {
            email: _validators.email
          },
          phone: {
            max: (0, _validators.maxLength)(11)
          },
          birthdate: {
            required: _validators.required,
            validDate: validDate
          },
          manager: {}
        }
      };
    }
    return {
      userData: {
        cpf: {
          required: _validators.required,
          min: (0, _validators.minLength)(10),
          validCPF: validCPF
        },
        firstName: {
          required: _validators.required,
          min: (0, _validators.minLength)(2)
        },
        lastName: {
          required: _validators.required,
          min: (0, _validators.minLength)(1)
        },
        role: {
          required: _validators.required,
          min: (0, _validators.minLength)(2)
        },
        temporary: {},
        temporaryExpirationDate: {
          max: (0, _validators.maxLength)(10)
        },
        scholarship: {
          required: _validators.required
        },
        password: {
          min: (0, _validators.minLength)(6)
        },
        passwordConfirm: {
          sameAsPassword: (0, _validators.sameAs)('password')
        },
        email: {
          required: _validators.required,
          email: _validators.email
        },
        phone: {
          required: _validators.required,
          max: (0, _validators.maxLength)(11)
        },
        birthdate: {
          required: _validators.required,
          validDate: validDate
        },
        manager: {}
      }
    };
  },
  watch: {
    userData: {
      handler: function handler(val) {
        var _this = this;
        if (!val.temporary) {
          this.userData.temporaryExpirationDate = null;
        }
        if (val.file) {
          var reader = new FileReader();
          reader.readAsDataURL(val.file);
          reader.onloadend = function () {
            _this.imageBase64 = reader.result;
          };
        }
      },
      deep: true
    }
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    farm: 'GET_FARM',
    listUsers: 'allUsers'
  })), {}, {
    isAdmin: function isAdmin() {
      return this.userEdit && _constants.LIST_ADMINS.includes(this.userEdit.role);
    },
    listManagers: function listManagers() {
      var _this2 = this;
      var users = this.listUsers.filter(function (i) {
        return (i.role === 'Coordinator' || i.role === 'Manager') && i.id !== _this2.userEdit.id;
      });
      return users;
    }
  }),
  mounted: function mounted() {
    if (!_lodash.default.isEmpty(this.userEdit)) {
      var edit = _lodash.default.cloneDeep(this.userEdit);
      var copia = Object.assign(this.userData, edit);
      this.userData = copia;
      if (this.userData.temporaryExpirationDate) this.userData.temporaryExpirationDate = (0, _moment.default)(this.userData.temporaryExpirationDate).format('DD/MM/YYYY');
      this.userData.birthdate = (0, _moment.default)(this.userData.birthdate).format('DD/MM/YYYY');
      this.imageUrl = this.userEdit.imageUrl;
      this.showPassword = false;
      if (this.isAdmin) {
        this.userData.role = this.userEdit.role;
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['createUser', 'updateUser', 'fetchUsers', 'bindUser', 'setLoading', 'fetchUsersWithQuery'])), {}, {
    setPassword: function setPassword(value) {
      this.userData.password = value;
      this.$v.userData.password.$touch();
    },
    setPasswordConfirm: function setPasswordConfirm(value) {
      this.userData.passwordConfirm = value;
      this.$v.userData.passwordConfirm.$touch();
    },
    submitFormUser: function submitFormUser(e) {
      e.preventDefault();
      var self = this;
      self.$v.userData.$touch();
      if (self.$v.userData.$error) {
        return self.$buefy.toast.open({
          message: 'Valide os campos do formulário',
          position: 'is-top',
          type: 'is-danger'
        });
      }
      var blockExpirationDate = self.userData.temporary && (0, _utils.validateEmail)(self.userData.email);
      var blockDate = self.userData.temporary && !(0, _moment.default)(self.userData.temporaryExpirationDate, 'DD/MM/YYYY', true).isValid();
      var dataValid = (0, _moment.default)(self.userData.temporaryExpirationDate, 'DD/MM/YYYY') < (0, _moment.default)();
      self.emailError = self.userData.role === 'Coordinator' && !(0, _utils.validateEmail)(self.userData.email);
      self.phoneError = self.userData.role === 'Coordinator' && (!self.userData.phone || self.userData.phone.length < 8);
      self.errortemporaryExpirationDate = blockDate;
      if (dataValid) self.errortemporaryExpirationDate = dataValid;
      if (self.emailError || self.phoneError || blockExpirationDate || blockDate || dataValid) {
        return this.$buefy.toast.open({
          message: 'Valide os campos do formulário',
          position: 'is-top',
          type: 'is-danger'
        });
      }
      if (!this.userEdit && !this.userExist) {
        if (!this.userData.password || !this.userData.passwordConfirm) {
          this.errorPassword = true;
          return this.$buefy.toast.open({
            message: 'Informe a senha de acesso para o funcionário',
            position: 'is-top',
            type: 'is-danger'
          });
        } else this.errorPassword = false;
      }
      if (!_lodash.default.isEmpty(this.userEdit)) return this.editUserRegister();
      if (!_lodash.default.isEmpty(this.userExist)) return this.linkUserToFarm();
      if (!this.userData.password) {
        return self.$buefy.toast.open({
          message: 'Por favor, crie uma senha para o usuário!',
          position: 'is-top',
          type: 'is-danger'
        });
      }
      this.createUserRegister();
    },
    createUserRegister: function () {
      var _createUserRegister = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var self, payload, data, response;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              self = this;
              payload = self.userData;
              data = {
                firstName: payload.firstName,
                lastName: payload.lastName,
                cpf: payload.cpf.match(/\d+/)[0],
                role: payload.role,
                password: payload.password.trim(),
                scholarship: payload.scholarship,
                birthdate: (0, _moment.default)(payload.birthdate, 'DD/MM/YYYY').toISOString(),
                manager: payload.manager
              };
              if (payload.email) data.email = payload.email;
              if (payload.phone) data.phone = payload.phone.match(/\d+/)[0];
              if (self.imageBase64) data.imageBase64 = self.imageBase64;
              if (payload.role === 'Operator') {
                data.temporary = payload.temporary;
                if (payload.temporaryExpirationDate) data.temporaryExpirationDate = (0, _moment.default)(payload.temporaryExpirationDate, 'DD/MM/YYYY').toISOString();
              }
              _context.n = 1;
              return self.createUser(data);
            case 1:
              response = _context.v;
              if (response) {
                self.getUsers();
                self.cancelModal();
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function createUserRegister() {
        return _createUserRegister.apply(this, arguments);
      }
      return createUserRegister;
    }(),
    editUserRegister: function () {
      var _editUserRegister = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var self, payload, data, response;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              self = this;
              payload = self.userData;
              data = {
                firstName: payload.firstName,
                lastName: payload.lastName,
                cpf: payload.cpf.match(/\d+/)[0],
                role: payload.role,
                scholarship: payload.scholarship,
                manager: payload.manager,
                birthdate: (0, _moment.default)(payload.birthdate, 'DD/MM/YYYY').toISOString(),
                farmId: this.farm.id
              };
              if (self.imageBase64) data.imageBase64 = self.imageBase64;
              if (payload.password) data.password = payload.password.trim();
              if (payload.email) data.email = payload.email;
              if (payload.phone) data.phone = payload.phone.match(/\d+/)[0];
              if (payload.role === 'Operator') {
                data.temporary = payload.temporary;
                if (payload.temporaryExpirationDate) data.temporaryExpirationDate = (0, _moment.default)(payload.temporaryExpirationDate, 'DD/MM/YYYY').toISOString();
              }
              _context2.n = 1;
              return self.updateUser({
                data: data,
                id: payload.id
              });
            case 1:
              response = _context2.v;
              if (response) {
                self.getUsers();
                self.cancelModal();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function editUserRegister() {
        return _editUserRegister.apply(this, arguments);
      }
      return editUserRegister;
    }(),
    linkUserToFarm: function () {
      var _linkUserToFarm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var data, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              data = {
                user: this.userExistData.id,
                farmId: this.farm.id
              };
              _context3.n = 1;
              return this.bindUser(data);
            case 1:
              res = _context3.v;
              if (res) {
                this.editUserRegister();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function linkUserToFarm() {
        return _linkUserToFarm.apply(this, arguments);
      }
      return linkUserToFarm;
    }(),
    cancelModal: function cancelModal() {
      this.$parent.close();
    },
    verifyUser: function () {
      var _verifyUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
        var user;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(_lodash.default.isEmpty(this.userEdit) && this.$v.userData.cpf.validCPF)) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return this.fetchUsersWithQuery({
                cpf: this.$v.userData.cpf.$model
              });
            case 1:
              user = _context4.v;
              if (user && Array.isArray(user) && user.length >= 1) {
                this.userExist = true;
                this.userExistData = user;
                if (Array.isArray(user)) this.userExistData = user[0];
                this.userData = Object.assign(this.userData, this.userExistData);
                if (this.userData.temporaryExpirationDate) this.userData.temporaryExpirationDate = (0, _moment.default)(this.userData.temporaryExpirationDate).format('DD/MM/YYYY');
                if (this.userData.birthdate) this.userData.birthdate = (0, _moment.default)(this.userData.birthdate).format('DD/MM/YYYY');
                if (!this.userData.temporary) this.userData.temporary = false;
                if (this.userData.password) this.userData.passwordConfirm = this.userData.password;
                this.showPassword = false;
                this.imageUrl = this.userExistData.imageUrl;
              } else {
                this.userExist = false;
                this.showPassword = true;
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function verifyUser(_x) {
        return _verifyUser.apply(this, arguments);
      }
      return verifyUser;
    }(),
    removePhoto: function removePhoto() {
      this.imageBase64 = '';
      this.imageUrl = '';
      this.userData.file = null;
    }
  })
};